import { request } from "./http";

export const createRecurringPlan = (body: {
  client_id: number | string;
  employee_id: number | string;
  room_id?: number | null;
  specialty_id?: number | null;
  name?: string;
  schedules: Array<{ weekday: number; start_time: string; end_time: string; first_date: string }>;
  price_cents?: number;
  billing_period?: 'monthly' | 'quarterly' | 'semiannual' | 'annual';
  billing_day?: number;
  insurance_provider_id?: number | null;
}) => request<{ id: number }>("/api/recurring/plans", { method: "POST", body: JSON.stringify(body) });

export const getRecurringPlan = (id: number) =>
  request<import("../types").RecurringPlan & { payments: import("../types").Payment[] }>(`/api/recurring/plans/${id}`);

export const deleteRecurringPlan = (id: number) => request(`/api/recurring/plans/${id}`, { method: "DELETE" });
